<template>
<div>
  <BreadCrumb :data="breadCrumb" /> 
  <Map 
    :coordsToTrack="coords" 
    :coordinates="center" 
  />
</div>
</template>

<script>
import Map from '@/components/Map'
import BreadCrumb from '@/components/BreadCrumb'

const  breadCrumb = [
  { label: "Raporlar", url: "/Reports" },
  { label: "Geçmiş İzleme", url: "/Reports/HistoryTracking" },
]

export default {
  components: {
    BreadCrumb, Map
  },
  data() {
    return {
      breadCrumb,
      coords: [
        [37.25, 28.366], [37.256, 28.376], [37.257, 28.386],
        [37.258, 28.386], [37.259, 28.386], [37.26, 28.386],
        [37.261, 28.383], [37.263, 28.380], [37.266, 28.375],
        [37.255, 28.383], [37.250, 28.380], [37.250, 28.366],
      ],
    }
  },
  computed: {
    center() {
      return {
        lat: this.coords[0][0],
        lng: this.coords[0][1]
      }
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/General/Reports/TrackHistory.vue